import React from 'react'
import { getEnv } from '../../../config'

function Info() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal mb-5">
  <p className="headline-lg">Basándonos en este concepto, definimos y publicamos una serie de Objetos Geográficos (OG)
  que, junto con sus metadatos, pueden accederse y descargarse a través del Portal de IDECABA.</p>
  </div>
  <div className="bg-dark d-flex justify-content-center align-items-center w-100 panel-horizontal">
    <a className="external link-white" href={getEnv("REACT_APP_GEONETWORK_URL")} target="_blank" rel="noopener noreferrer">Catálogo de Metadatos</a>
  </div>
</div>

  )
}

export default Info